export default __webpack_public_path__ + "static/media/com-new-balance.329cd5b7.mp4";